import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.customerDistributionTypes.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.customerDistributionTypes.actionsLoading;
export const getItems = (state:RootState) => state.customerDistributionTypes.items;
export const getItemsSelect = (state:RootState) => state.customerDistributionTypes.dropDownItems;
export const getItemsCount = (state:RootState) => state.customerDistributionTypes.itemsCount;
export const getItemForEdit = (state:RootState) => state.customerDistributionTypes.itemForEdit;
export const getError = (state:RootState) => state.customerDistributionTypes.error;
export const getErrorAction = (state:RootState) => state.customerDistributionTypes.errorAction;
export const validationErrors = (state: RootState) => state.customerDistributionTypes.validationErrors;